export const getTitle = (title?: string) => {
  const appTitle = import.meta.env.VITE_APP_TITLE || "BMD Chat AI";
  const pageTitle = title?.trim();

  return pageTitle ? `${pageTitle} - ${appTitle}` : appTitle;
};

/**
 * Format number to VND.
 * Example: formatVND(10000);           // '10.000'
 */
export function formatVND(num: number) {
  return `${num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
}
